import React, { useMemo } from 'react';
import type { KitPictogram, PictogramKind } from '../constants/pictograms';
import { pictogramsOf } from '../constants/pictograms';
import { mediaSrc } from '../utils/media';

interface PictogramPickerProps {
  kind: PictogramKind;
  value?: string | null;
  onChange: (icon: KitPictogram) => void;
}

export function PictogramPicker({ kind, value, onChange }: PictogramPickerProps) {
  const icons = useMemo(() => pictogramsOf(kind), [kind]);

  return (
    <div className={`pictogram-picker${kind === 'spell' ? ' pictogram-picker-spell' : ''}`}>
      <div className="pictogram-row">
        {icons.map(icon => (
          <button
            key={icon.id}
            type="button"
            className={`icon-btn pictogram-btn ${value === icon.src ? 'selected' : ''}`}
            onClick={() => onChange(icon)}
            title={icon.name}
            aria-label={icon.name}
            aria-pressed={value === icon.src}
          >
            <img src={mediaSrc(icon.src)} alt="" />
          </button>
        ))}
      </div>
    </div>
  );
}
